<template>
  <BContainer>
    <BRow h-align="center">
      <b-col></b-col>
      <BCol lg="10" class="text-center">
        <h2 class="my-4">Make the execution as powerful as your vision</h2>
        <p>Visual storytelling is a blend of art and science, leveraging the power of visual media to create experiences that are rich in emotion and personality.</p>
        <p>It’s clear that with so many kinds of visual media, understanding how visual stories are consumed is essential to ensuring brands can deliver on the experience their audiences need—around the world and across all kinds of platforms and devices.</p>
        <a href="https://www.cloudinary.com">
          <button class="mt-5 mb-3">About Cloudinary</button>
        </a>
        <p>
          Cloudinary provides a cloud-based media full-stack platform for the world’s top brands. With offices in the US, UK and Israel, Cloudinary has quickly become the de facto solution for web developers and marketers to manage images, videos and other rich media assets and deliver an optimal end user experience.
          <br />For more information, visit <a href="https://www.cloudinary.com">www.cloudinary.com</a>.
        </p>
        <footer class="d-inline-block text-left">
          <b-row>
            <b-col>
              <small>
                <strong>About the data:</strong>
                <p>The data analyzed for this report comprises engagement patterns during the fourth quarter of 2018 across more than 700 Cloudinary customers, spanning more than a dozen vertical industries and a representative sampling of over 200 billion transactions per month.</p>
              </small>
            </b-col>
            <b-col>
              <small>
                <strong>Sources:</strong>
                <p>1. MIT News. 2. Fast Company. 3. Nielsen Global Brand-Origin Study. 4. Fast Company. 5. Ogilvy Cannes.</p>
              </small>
            </b-col>
          </b-row>
        </footer>
      </BCol>
      <b-col></b-col>
    </BRow>
  </BContainer>
</template>

<script>
// import LearnMore from "../LearnMore.vue";
// import ChartDonut from "../donut-filled.vue";

export default {
  components: {
    // LearnMore,
    // ChartDonut
  },
  props: {
    numbers: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
  // computed: { }
};
</script>

<style lang="scss" scoped>
button {
  color: white;
  background: $blue;
  border: 2px solid $blue;
  border-radius: 1em;
  padding: 0.25em 2em;
  &:hover {
    color: $lightgrey;
    border: 2px solid $blue2;
  }
}
a {
  color: inherit;
  text-decoration: underline;
  &:hover {
    color: $blue;
  }
}
</style>
